export default __webpack_public_path__ + "static/media/atlassian_icon.76c32abb.svg";